export enum TransactionStatus {
    Pending,
    Complete,
}

export enum PaymentType {
    periodic,
    early,
    late,
}

export enum TransactionCategory {
    Funding = 'Funding',
    Repayment = 'Repayment',
    OriginationFee = 'Origination Fee',
    Fees = 'Fees',
    Adjustments = 'Adjustments',
}

export interface ProductSummary {
    advance_rate?: number;
    contract_end_date?: string;
    contract_start_date?: string;
    funds_available?: number;
    funds_in_use?: number;
    id?: string;
    max_days_outstanding?: number;
    number_of_active_deals?: number;
    origination_fee_percentage?: number;
    product?: string;
    qualified_amount?: number;
    term_length_in_days?: number;
    total_in_process_amount?: number;
    total_payoff_amount?: number;
}
